import { HeaderNavLink } from './view';
export default HeaderNavLink;
